import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  box: {
    border: '1px solid #ddd',
  },
  headerFormat: {
    height: '14px',
    fontSize: '0.9em',
    fontWeight: 'bold',
    marginTop: '-4px',
    marginBottom: '4px',
  },
  contentFormat: {
    height: '12px',
    fontSize: '0.85em',
    marginTop: '-3px',
    marginBottom: '3px',
  },
  totalFormat: {
    height: '12px',
    fontSize: '0.85em',
    fontWeight: 'bold',
    marginTop: '-2px',
    marginBottom: '2px',
  },
  doubleHeight: {
    height: '30px !important',
  },
  cellFormat: {
    border: 'none',
  },
  cellFormatHeaderFirst: {
    backgroundColor: '#eee',
  },
  cellFormatHeaderAfter: {
    backgroundColor: '#eee',
    textAlign: 'right',
  },
  cellFormatTotal: {
    borderTop: '1px solid #ddd',
  },
  numeric: {
    textAlign: 'right',
  },
}));


export default function LedgerTable(props) {
  const { columns, data, showTotal, className } = props;

  const classes = useStyles();

  var total = 0;
  if (showTotal) {
    for (var row of data) {
      total += row[showTotal];
    }
  }

  function getCellContent(row, index) {
    // For now, index 3 of the row fields is not data to display but signifies the height of the row
    const HEIGHT_FIELD = 3;
    return formatContent(row[index], 0, row[HEIGHT_FIELD]);
  }

  function formatContent(val, rowType, height) {
    // rowType:
    //   0: regular
    //   1: header
    //   2: total
    var formatClass = '';
    if ([0, 1, 2].includes(rowType)) {
      formatClass = [
        classes.contentFormat,
        classes.headerFormat,
        classes.totalFormat
      ][rowType];
    }

    if (typeof val === 'number') {
      return (
        <Grid item className={`${classes.numeric} ${formatClass} ${height === 2 && classes.doubleHeight}`}>
          {val}
        </Grid>
      );
    } else {
      return (
        <Grid item className={`${formatClass} ${height === 2 && classes.doubleHeight}`}>
          {val}
        </Grid>
      );
    }
  }

  return (
    <Box className={`${classes.box} ${className}`}>
      {columns && data && (
        <TableContainer>
          <Table size={'small'}>
            <TableHead>
              <TableRow>
                {columns && columns.map((col, index) => (
                  <TableCell
                    key={index}
                    className={index === 0 ? classes.cellFormatHeaderFirst : classes.cellFormatHeaderAfter}
                  >
                    {formatContent(col, 1)}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => {
                return (
                  <TableRow key={index}>
                    {columns.map((col, i) =>
                      <TableCell key={i} className={classes.cellFormat}>
                        {getCellContent(row, i)}
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
              {showTotal !== undefined && (
                <TableRow>
                  <TableCell colSpan={showTotal} className={classes.cellFormatTotal}>
                    {formatContent('TOTAL', 2, 1)}
                  </TableCell>
                  <TableCell className={classes.cellFormatTotal}>
                    {formatContent(total, 2, 1)}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
